// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2_3zC","col":"Table_col__1UuZ3","fulfillmentStatus":"Table_fulfillmentStatus__2Gjvu","emailCol":"Table_emailCol__2T4hf"};